
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wenn weder Schlafrituale, pflanzliche Medikamente noch die Änderung gewisser Lebensgewohnheiten den Schlaf zurückbringen, kann eine Hormonersatz-Therapie (HET) helfen. Patientinnen, die noch eine Gebärmutter besitzen, werden mit Östrogenen und Progesteron behandelt. Für Brustkrebspatientinnen ist die HET allerdings nicht möglich. Die Gabe sogenannt bioidentischer Hormone, exakte Kopien körpereigener Hormone, erfolgt nicht nur in Tablettenform, sondern auch als Pflaster oder Gel, weil diese Varianten als besser verträglich gelten. Eine HET soll Hitzewallungen um 75 Prozent verbessern. `}<br /><br />{`
Bis Anfang der 2000er-Jahre wurden Hormone quasi im Giesskannenprinzip an Frauen abgegeben. Doch dann kam es zu einer abrupten Kehrtwendung: Nach der Auswertung der breit angelegten, amerikanischen «Women’s Health Initiative» hiess es plötzlich, dass Frauen, die Hormone einnehmen, ein viel grösseres Risiko hätten, an Herz-Kreislauf Krankheiten, Thrombosen und Brustkrebs zu erkranken. Dadurch erlebte die ärztliche Hormonabgabe Anfang der 2000er-Jahre einen weltweiten Einbruch. Erst Jahre später wurde sie rehabilitiert: Mit einer weiteren gross angelegten Studie wurde bewiesen, dass die ehemaligen Probandinnen der ersten Studie zu alt waren und an verschiedenen Vorerkrankungen gelitten haben. `}<M mdxType="M">{`Heute gilt bei der HET die Devise: So früh wie möglich und so wenig wie möglich.`}</M></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;